var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M3.63.45a.444.444 0 0 1 .367.384L4.392 4h2.72a.445.445 0 0 1 .397.643L4.842 9.977a.444.444 0 0 1-.839-.144l-.395-3.166H.888a.444.444 0 0 1-.397-.644L3.158.69a.444.444 0 0 1 .473-.24z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }